import styled from 'styled-components';
import * as G from '../../theme/global-styles';

export const Container = styled(G.Container)`
    padding: 0;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    overflow-y: auto;
`;

export const Description = styled(G.Description)`
    text-align: justify;
    width: 100%;
`;

export const InsuranceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    overflow-y: auto;
    gap: 16px;
    margin-top: 0px;
    padding: 0 16px;
`;

export const Subtitle = styled(G.Title)`
    font-size: 16px;
    font-weight: 700;
`;

export const Indent = styled.div`
    padding-left: 32px;
    width: 100%;
`;

export const UnorderedList = styled.ul`
    padding: 0;
    margin: 0;
`;

export const OrderedList = styled.ol`
    padding: 0;
    margin: 0;
`;

export const ListItem = styled.li`
    font-size: 14px;
    margin: 0 0 8px 0;
    font-weight: 400;
    color: #232323;

`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
    padding: 0px 16px;
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    border-top: 1px dashed #737373;
`;

export const Data = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
`;

export const DataLabel = styled(G.Description)`
    font-weight: 600;
`;

export const DataValue = styled(G.Description)``;

export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const CheckboxLabel = styled(G.Description)`
    font-size: 12px;
`;

export const Label = styled.label`
    font-size: 12px;
    margin: 0;
    font-weight: 400;
    color: #232323;
`;
